import { render, staticRenderFns } from "./CraftInfoTab.vue?vue&type=template&id=04b5aa2e&scoped=true"
import script from "./CraftInfoTab.vue?vue&type=script&lang=js"
export * from "./CraftInfoTab.vue?vue&type=script&lang=js"
import style0 from "./CraftInfoTab.vue?vue&type=style&index=0&id=04b5aa2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b5aa2e",
  null
  
)

export default component.exports